export default function LeaderboardHero() {
  return (
    <section className="relative min-h-[75vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-purple-900/30 to-gray-900">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-10"></div>
        </div>
      </div>
      
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/70529b2237132e09a24cbc1102c8434d.jpg"
          alt="Leaderboard"
          className="w-full h-full object-cover object-center opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-purple-900/40 to-black/60"></div>
      </div>
      
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <div className="inline-flex items-center bg-purple-600/20 border border-purple-500/50 rounded-full px-5 py-2 mb-6 backdrop-blur-sm">
          <i className="ri-trophy-line text-purple-400 mr-2"></i>
          <span className="text-purple-300 font-semibold text-sm">SEASON 2024 RANKINGS</span>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Global <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">Leaderboard</span>
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed">
          Compete with the best Brawlhalla players worldwide. Climb the ranks, earn points, and prove you're the ultimate champion in the Revenant League.
        </p>
        
        <div className="flex flex-wrap justify-center gap-6 mb-12">
          <div className="bg-gray-800/60 backdrop-blur-sm rounded-xl px-8 py-6 border border-purple-500/30 shadow-lg shadow-purple-500/20">
            <div className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-2">12,847</div>
            <div className="text-gray-400 text-sm">Active Players</div>
          </div>
          <div className="bg-gray-800/60 backdrop-blur-sm rounded-xl px-8 py-6 border border-purple-500/30 shadow-lg shadow-purple-500/20">
            <div className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-2">156</div>
            <div className="text-gray-400 text-sm">Countries</div>
          </div>
          <div className="bg-gray-800/60 backdrop-blur-sm rounded-xl px-8 py-6 border border-purple-500/30 shadow-lg shadow-purple-500/20">
            <div className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-2">$2.5M</div>
            <div className="text-gray-400 text-sm">Total Prize Pool</div>
          </div>
        </div>
        
        <div className="flex flex-wrap justify-center gap-4">
          <button className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 shadow-lg shadow-purple-500/50 cursor-pointer whitespace-nowrap">
            <i className="ri-user-add-line mr-2"></i>
            Join Rankings
          </button>
          <button className="bg-gray-800/80 backdrop-blur-sm border-2 border-purple-500/50 text-purple-300 hover:bg-purple-600 hover:text-white hover:border-purple-600 px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap">
            <i className="ri-download-line mr-2"></i>
            Download Stats
          </button>
        </div>
      </div>
    </section>
  );
}
